import Vue from 'vue';
//引入公共配置
import '../../../asset/vendor/common_conf'
// 引入基础框架
import App from 'bjxy-component/app/wallet.vue';
// 初始化基础的路由
import baseRouter from 'bjxy-common/baseRouter';
// 初始化基础的Store
import baseStore from 'bjxy-common/baseStore';
// 基础网络操作
import ajax from 'bjxy-common/network';
// Vue 基础方法扩展
import vuePlugin from 'bjxy-common/vuePlugin';
// 页面路由
import router from './router';
// 页面数据仓库
import pageStore from './store';

// 页面数据上报
import { index as Reporter} from "bjxy-report";
import getQueryString from 'bjxy-common/helper/getQueryString';

let landId = getQueryString('landId');
let source = getQueryString('source');

// 以下是业务引入

let store = baseStore(pageStore);
ajax(store,{data:{source,landId},slientError: true, withCredentials: true});
baseRouter(router, store);

Reporter.init(Vue, router, store);

Vue.use(vuePlugin, {store: store});

new Vue({
  el: '#container',
  router,
  store,
  render(createElement) {
    return createElement(App);
  },
});









// WEBPACK FOOTER //
// ./src/module/blueRegPage/index/index.js